module.exports = "<div\n    v-show=\"show\"\n    class=\"alert\"\n    v-class=\"\n      alert-success:type == 'success',\n      alert-warning:type == 'warning',\n      alert-info:type == 'info',\n      alert-danger:type == 'danger',\n      top: placement === 'top',\n      top-right: placement === 'top-right'\n    \"\n    v-transition=\"fade\"\n    v-style=\"width:width\"\n    role=\"alert\">\n    <button v-show=\"dismissable\" type=\"button\" class=\"close\"\n      v-on=\"click:show = false\">\n      <span >&times;</span>\n    </button>\n    <content>\n    </content>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Alert.vue
 ** module id = 29
 ** module chunks = 0
 **/